import { render, staticRenderFns } from "./OnlineOrderDevice.vue?vue&type=template&id=fc6fa894&"
import script from "./OnlineOrderDevice.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports